import React from 'react'
import {RecruitDataWrapper} from './styles'
export const RecruitData = () => {
  return (
    <RecruitDataWrapper>
      <table>
      <tr>
      <th>求人職種</th>
      <td>店長候補</td>
      </tr>
      <tr>
      <th>給与</th>
      <td>月給26万円～（経験によって増減有)</td>
      </tr>
      <tr>
      <th>求める人物像・資格</th>
      <td>実店舗の店長候補およびニューノーマルに適したカテゴリーマネージャー募集<br/>
          ECサイトの運営やマーケティング業務の経験のある方歓迎！<br/>
          ポジティブシンキングができる方歓迎<br/>
          現状を改善・打破したい人<br/>
          </td>
      </tr>
      <tr>
      <th>交通費</th>
      <td>全額支給</td>
      </tr>  
      <tr>
      <th>勤務地詳細</th>
      <td>〒231-0046 神奈川県横浜市中区末広町３丁目８８−１</td>
      </tr> 
      <tr>
      <th>待遇</th>
      <td>●各種社会保険完備<br/>
          ●随時昇給<br/>
          ●実績賞与<br/>
          ●研修期間有（1ヶ月）<br/>
          ●食事付<br/>
     </td>
      </tr> 
      <tr>
      <th>休日休暇</th>
      <td>月4〜8休み(シフト制)、年末年始夏季休暇有、他</td>
      </tr> 
      <tr>
      <th>勤務時間</th>
      <td>飲食店経営　屋号「韓国料理どやじ 」</td>
      </tr>
      <tr>
      <th>連絡先</th>
      <td>弊社採用担当まで</td>
      </tr>      
      </table> 
    </RecruitDataWrapper>
  )
}

